import React, { useRef, FC } from 'react';
import { useOnScreen } from '../../../../utils/hooks/useOnScreen';
import { LightUploadingFile, UploadingFile } from '../UploadingFile';
import { IOuter } from './UploadingItem.types';

export const UploadingItem: FC<IOuter> = ({ item, shouldStayVisible, onOpenDestinationFolder, currentFolder }) => {
  const itemRef = useRef();
  const isVisible = useOnScreen(itemRef);

  return (
    <div ref={itemRef}>
      {shouldStayVisible || isVisible ? (
        <UploadingFile
          uploadingFile={item}
          onOpenDestinationFolder={onOpenDestinationFolder}
          currentFolder={currentFolder}
        />
      ) : (
        <LightUploadingFile />
      )}
    </div>
  );
};
